/**
 * ExploreCategorySwitch - Renders different category types based on category.type
 * Created by neo on 21.01.26
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { ExploreCategory } from '../../Model/Explore/ExploreCategory';
import { ExploreCategoryCardLink } from './ExploreCategoryCardLink';
import { ExploreCategoryPreview } from './ExploreCategoryPreview';
import { ExploreCategoryBigPreview } from './ExploreCategoryBigPreview';
import { ExploreCategoryGroup } from './ExploreCategoryGroup';
import { ExploreCategoryRecipeFavorites } from './ExploreCategoryRecipeFavorites';
import { ExploreCategoryRecipeAll } from './ExploreCategoryRecipeAll';
import { ExploreCategorySingleExercises } from './ExploreCategorySingleExercises';

export type ExploreCategorySwitchProps = {
  category: ExploreCategory;
  categoryIndex?: number;
  isLast?: boolean;
  linkPrefix?: string;
};

export const ExploreCategorySwitch: React.FC<ExploreCategorySwitchProps> = observer(
  ({ category, categoryIndex = 0, isLast, linkPrefix = '/' }) => {
    switch (category.type) {
      case 'card_link':
        return <ExploreCategoryCardLink category={category} linkPrefix={linkPrefix} />;

      case 'recipe_favorites':
        return <ExploreCategoryRecipeFavorites category={category} linkPrefix={linkPrefix} />;

      case 'recipe_all':
        return <ExploreCategoryRecipeAll category={category} linkPrefix={linkPrefix} />;

      case 'single_exercises':
        return <ExploreCategorySingleExercises category={category} linkPrefix={linkPrefix} />;

      case 'big_preview':
        return <ExploreCategoryBigPreview category={category} isLast={isLast} linkPrefix={linkPrefix} />;

      case 'category_group':
        return <ExploreCategoryGroup category={category} isLast={isLast} linkPrefix={linkPrefix} />;

      case 'link_list':
        return null;
      case 'tools':
        return null;
      case 'preview':
      case 'recipe_recommendations':
      default:
        return (
          <ExploreCategoryPreview
            category={category}
            categoryIndex={categoryIndex}
            isLast={isLast}
            linkPrefix={linkPrefix}
          />
        );
    }
  },
);
